import { createReducer, on } from '@ngrx/store';
import { get as _get } from 'lodash';

import { ApiStatus, initialApiStatus } from '@amfam/shared/models';

import {
  addressChangeAgentEmailSuccess,
  addressChangeANSSuccess,
  addressChangeNotification,
  addressChangeNotificationFailed,
  addressChangeNotificationSuccess,
  driverLicenseChangeANSFailed,
  driverLicenseChangeANSSuccess,
  PolicyChangeRequestNotificationAction,
  PolicyChangeRequestNotificationFailAction,
  PolicyChangeRequestNotificationSuccessAction,
  PolicyChangeRequestResetStateAction,
  PolicyChangeRequestSetCancelPathAction,
  PolicyChangeRequestSuccessEmailNotificationAction,
  vinChangeAgentEmailSuccess,
  vinChangeANSSuccess,
  vinChangeNotificationSuccess
} from './policy-change.actions';

export interface State {
  error: ApiStatus | null;
  success: ApiStatus | null;
  loading: boolean;
  cancelNavigationPath: string;
}

export const initialState: State = {
  error: null,
  success: null,
  loading: false,
  cancelNavigationPath: '/policies'
};

export const reducer = createReducer(
  initialState,
  on(
    addressChangeNotification,
    addressChangeNotification,
    PolicyChangeRequestNotificationAction,
    (state, action) => ({
      ...state,
      loading: true,
      error: null
    })
  ),
  on(
    addressChangeAgentEmailSuccess,
    addressChangeANSSuccess,
    addressChangeNotificationSuccess,
    driverLicenseChangeANSSuccess,
    vinChangeAgentEmailSuccess,
    vinChangeANSSuccess,
    vinChangeNotificationSuccess,
    PolicyChangeRequestSuccessEmailNotificationAction,
    PolicyChangeRequestNotificationSuccessAction,
    (state, action) => ({
      ...state,
      success: _get(action, 'payload.status', initialApiStatus),
      error: null,
      loading: false
    })
  ),
  on(
    addressChangeNotificationSuccess,
    driverLicenseChangeANSSuccess,
    addressChangeNotificationSuccess,
    PolicyChangeRequestSuccessEmailNotificationAction,
    PolicyChangeRequestNotificationSuccessAction,
    (state, action) => ({
      ...state,
      success: _get(action, 'payload.status', initialApiStatus),
      error: null,
      loading: false
    })
  ),
  on(
    PolicyChangeRequestNotificationFailAction,
    addressChangeNotificationFailed,
    driverLicenseChangeANSFailed,
    addressChangeNotificationFailed,
    (state, action) => ({
      ...state,
      error: _get(action, 'payload', initialApiStatus),
      success: null,
      loading: false
    })
  ),
  on(PolicyChangeRequestSetCancelPathAction, (state, action) => ({
    ...state,
    cancelNavigationPath: _get(action, 'payload', ''),
    loading: false
  })),
  on(PolicyChangeRequestResetStateAction, (state, action) => initialState)
);

export const getError = (state: State) => state.error;
export const getSuccess = (state: State) => state.success;
export const getLoading = (state: State) => state.loading;
export const getCancelPath = (state: State) => state.cancelNavigationPath;
